import { render } from "./kalio-flash-alert.vue?vue&type=template&id=eb7d39f6"
import script from "./kalio-flash-alert.vue?vue&type=script&lang=js"
export * from "./kalio-flash-alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__